var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 4.8005C6.8999 4.19299 7.39239 3.7005 7.9999 3.7005H18.9928L25.0999 9.80761V27.2005C25.0999 27.808 24.6074 28.3005 23.9999 28.3005H7.9999C7.39239 28.3005 6.8999 27.808 6.8999 27.2005V4.8005Z",
    fill: "#F4FBFF",
    stroke: "#75C7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 3.20001L25.6002 9.60001H20.8002C19.9165 9.60001 19.2002 8.88367 19.2002 8.00001V3.20001Z",
    fill: "#75C7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3602_513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.3333C12 20.9651 12.2985 20.6666 12.6667 20.6666H20.6667C21.0349 20.6666 21.3333 20.9651 21.3333 21.3333C21.3333 21.7015 21.0349 22 20.6667 22H12.6667C12.2985 22 12 21.7015 12 21.3333Z",
    fill: "#75C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16C12 15.6318 12.2985 15.3333 12.6667 15.3333H20.6667C21.0349 15.3333 21.3333 15.6318 21.3333 16C21.3333 16.3682 21.0349 16.6666 20.6667 16.6666H12.6667C12.2985 16.6666 12 16.3682 12 16Z",
    fill: "#75C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6667C12 18.2985 12.2985 18 12.6667 18H20.6667C21.0349 18 21.3333 18.2985 21.3333 18.6667C21.3333 19.0349 21.0349 19.3333 20.6667 19.3333H12.6667C12.2985 19.3333 12 19.0349 12 18.6667Z",
    fill: "#75C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 15.3333,
    width: 1.33333,
    height: 1.33333,
    fill: "#2F2F45",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 18,
    width: 1.33333,
    height: 1.33333,
    fill: "#2F2F45",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3333C12 12.9651 12.2985 12.6666 12.6667 12.6666H20.6667C21.0349 12.6666 21.3333 12.9651 21.3333 13.3333C21.3333 13.7015 21.0349 14 20.6667 14H12.6667C12.2985 14 12 13.7015 12 13.3333Z",
    fill: "#75C7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 12.6666,
    width: 1.33333,
    height: 1.33333,
    fill: "#2F2F45",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 23.6318 12.2985 23.3333 12.6667 23.3333H18.6667C19.0349 23.3333 19.3333 23.6318 19.3333 24C19.3333 24.3682 19.0349 24.6666 18.6667 24.6666H12.6667C12.2985 24.6666 12 24.3682 12 24Z",
    fill: "#75C7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83488 10.9074L12.1076 9.34986C12.7433 9.24309 13.3333 9.66653 13.3333 10.2295V25.7706C13.3333 26.3255 12.759 26.7469 12.1299 26.6537L2.85718 25.2793C2.3621 25.206 2 24.8329 2 24.3962V11.787C2 11.3578 2.35017 10.9889 2.83488 10.9074Z",
    fill: "#3862D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4668 13.6666L9.73308 13.8077L8.71461 19.6436L7.71947 13.9655L6.51442 14.0651L5.52705 19.4942L4.75737 14.2062L3.4668 14.3141L4.79624 21.6941L6.18011 21.8269L7.08196 17.0287L7.95271 22.0012L9.55426 22.159L11.4668 13.6666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 20.6666,
    width: 1.33333,
    height: 1.33333,
    fill: "#2F2F45",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3335,
    y: 23.3333,
    width: 1.33333,
    height: 1.33333,
    fill: "#2F2F45",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3602_513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6667,
    height: 17.3333,
    fill: "white",
    transform: "translate(1.3335 9.33331)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocx);
export default __webpack_public_path__ + "static/media/docx.0597d5dc9d93693d488b0ad7337e5639.svg";
export { ForwardRef as ReactComponent };